export default __webpack_public_path__ + "static/sepro-41a181ccdb6e7e6678a6fec6a3f26ca3.mp4";